module.exports = __webpack_public_path__ + "img/studio_metricas_proprietarias.3b29007e.png";